import { combineReducers } from "redux";
import { billingReducer } from "./modules/billing/reducer";
import commodityReducer from "./modules/commodities/reducer";
import DrawerReducer from "./modules/common/reducer";
import commVarReducer from "./modules/commvarieties/reducer";
import { contactUSReducer } from "./modules/contactUS/reducer";
import { contractReducer } from "./modules/contract/reducer";
import counterPartyReducer from "./modules/counterparties/reducer";
import { dashboardReducer } from "./modules/dashboard/reducer";
import destReducer from "./modules/destinations/reducer";
import { FarmInformationReducer } from "./modules/farmInformation/reducer";
import FarmManagementReducer from "./modules/farmManagement/reducer";
import fieldGroupReducer from "./modules/fieldgroups/reducer";
import fieldReducer from "./modules/fields/reducer";
import resetPasswordReducer from "./modules/forgotPassword/reducer";
import { harvestYearReducer } from "./modules/harvestYearManagement/reducer";
import loadReducer from "./modules/loadnoindicator/reducer";
import { mandatoryFieldsReducer } from "./modules/mandatoryFields/reducer";
import { preferencesReducer } from "./modules/preferences/reducer";
import productsReducer from "./modules/products/reducer";
import { reconciliationReducer } from "./modules/reconciliation/reducer";
import ReportsReducer from "./modules/reports/reducer";
import riskReducer from "./modules/riskmanagement/reducer";
import { globalserverMessage } from "./modules/serverMessage/reducer.js";
import { subscriptionList } from "./modules/subscription/reducer";
import { ticketReducer } from "./modules/ticket/reducer";
import trucklineReducer from "./modules/truckline/reducer";
import { userReducer } from "./modules/user/redux/reducer";
import userManagementReducer from "./modules/userManagement/reducer";
import settingsUserReducer from "./modules/users/reducer";
import { selectedCommodityReducer } from "./modules/inventorystatus/reducer";

export default combineReducers({
  user: userReducer,
  subscriptionList: subscriptionList,
  contractReducer: contractReducer,
  dashboardReducer: dashboardReducer,
  trucklineReducer,
  FarmInformationReducer,
  ticketReducer: ticketReducer,
  destReducer,
  commodityReducer,
  globalserverMessage,
  fieldGroupReducer,
  commVarReducer,
  counterPartyReducer,
  DrawerReducer,
  FarmManagementReducer,
  fieldReducer,
  loadReducer,
  riskReducer,
  ReportsReducer,
  settingsUserReducer,
  resetPasswordReducer,
  reconciliationReducer,
  mandatoryFieldsReducer,
  contactUSReducer,
  userManagementReducer,
  harvestYearReducer,
  productsReducer,
  billingReducer,
  preferencesReducer,
  selectedCommodityReducer
});



// WEBPACK FOOTER //
// ./src/rootReducer.js